import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User opened edit person modal',
  name: 'opened_edit_person_modal',
  params: [
    {
      description: 'The id of the person',
      name: 'person_id',
      required: true,
      type: 'string',
    },
    {
      description: 'Location of event',
      name: 'location',
      required: true,
      type: 'enum',
      values: [
        'image-preview',
        'people-tab',
        'named-people-page',
        'unnamed-people-page',
        'person-page-header',
        'person-page-menu',
        'people-settings',
      ],
    },
  ],
};

export default META;
